import { createQueriesContext } from "@polifonia/utils/react-query/createQueriesContext";

import { interlude } from "@/interlude";

const useChannelQueries = (channelId: number) => {
  const channelQuery = interlude.channel.useSuspenseGetById({
    params: {
      channelId,
    },
  });

  return {
    channel: channelQuery,
  };
};

const ChannelQueriesContext =
  createQueriesContext<ReturnType<typeof useChannelQueries>>();

export { ChannelQueriesContext, useChannelQueries };
